export default __webpack_public_path__ + "static/media/pictogramHealthInsurance64.87803597.svg";